import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { EndPoints } from "../../../Constants/endpoints";
import { useGetData } from "../../../hooks";
import { GetArticles } from "../../../interface/GeneralResponse";
import { ArticleCard } from "../../../Share";

function HomeArticles() {
  const { t } = useTranslation();
  const { data: articleData, isPending } = useGetData<GetArticles[]>(
    EndPoints.GetAllArticles,
    {
      filter: {
        Count: 5,
      },
    },
  );
  return (
    <div className="box flex max-h-full w-full flex-1 flex-col gap-3 overflow-y-auto">
      <div className="flex justify-between">
        <h3 className="font-bold">{t("domecare_articles")}</h3>
        <Link className="text-sm font-bold text-primary" to="/articles">
          {t("see_all")}
        </Link>
      </div>
      {isPending
        ? Array.from({ length: 5 }).map((_, index) => (
            <div className="flex items-center gap-2" key={index}>
              <div className="bg-silver mb-2 h-12 w-12 animate-pulse rounded-xl" />
              <div>
                <div className="bg-silver mb-2 h-4 w-40 animate-pulse rounded-md" />
                <div className="bg-silver mb-2 h-4 w-72 animate-pulse rounded-md" />
              </div>
            </div>
          ))
        : articleData?.Data?.length !== 0 &&
          articleData?.Data?.map((e) => (
            <ArticleCard
              key={e.Id}
              item={e}
              link={`/articles/${e.Id}/${e.Title}`}
            />
          ))}
    </div>
  );
}

export default HomeArticles;
// 996435645
